import { action, makeAutoObservable, runInAction } from 'mobx'

import { noticeController } from '@/controller/notice.controller'
import type { Banner, User } from '@/dto'

class _BannerService {
  banner?: Banner
  private _nextBanner?: Banner

  constructor() {
    makeAutoObservable(this)
  }

  private async _fetchBanner(user: User, isSchoolflat: boolean, excludeIds?: Banner['id'][]) {
    const banner = await noticeController.fetchBanner(user, isSchoolflat, excludeIds)

    return banner
  }

  async handleInitBanner(
    user: User,
    isSchoolflat: boolean,
    afterBannerFetch?: (banner: Banner) => void,
  ) {
    try {
      if (this.banner) {
        return
      }

      const banner = await this._fetchBanner(user, isSchoolflat)
      if (banner) {
        afterBannerFetch?.(banner)
        runInAction(() => {
          this.banner = banner
        })
        this.handleFetchNextBanner(user, isSchoolflat)
      }
    } catch (e) {
      console.error(e)
    }
  }

  async handleFetchNextBanner(user: User, isSchoolflat: boolean) {
    try {
      const excludeIds: Banner['id'][] = []

      this.banner && excludeIds.push(this.banner.id)
      this._nextBanner && excludeIds.push(this._nextBanner.id)

      const banner = await this._fetchBanner(user, isSchoolflat, excludeIds)
      if (banner) {
        runInAction(() => {
          this._nextBanner = banner
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  shiftNextBanner() {
    this.banner = this._nextBanner
    this._nextBanner = undefined
  }
}

const BannerService = new _BannerService()
export default BannerService
